import * as React       from 'react';
import Typography       from '@mui/material/Typography';
import Button           from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import {
    DELETE_CLASS_POPUP_DELETE,
    DELETE_CLASS_POPUP_TEXT_1,
    DELETE_CLASS_POPUP_TEXT_2
}                       from 'config/config';
import { HttpClient, ApiError } from 'apiclient/ApiClient';

const DeleteClass = (props: {
    closePopup: ()=>void,
    classId: string,
    className: string,
    invalidate: ()=>void
}) => {
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState('');
    const client = HttpClient();
    const deleteClass = async () => {
        setError('');
        setLoading(true);
        try {
            await client.delete(`/classes/${props.classId}`);
            props.invalidate();
            props.closePopup();
        } catch (err) {
            if (err instanceof ApiError) {
                setError(err.message || 'Failed to delete class. Please try again.');
            } else {
                setError('An unexpected error occurred. Please try again.');
            }
        } finally {
            setLoading(false);
        }
    };
    return(
        <>
            <Typography sx={{ width: '100%', textAlign: 'center' }}>
                {DELETE_CLASS_POPUP_TEXT_1}
                {props.className}
                {DELETE_CLASS_POPUP_TEXT_2}
            </Typography>
            {error &&
                <Typography color='error' sx={{ textAlign: 'center' }}>{error}</Typography>
            }
            <Button
                fullWidth
                onClick={deleteClass}
                variant='contained'
                color='error'
                disabled={loading}
                sx={{ boxShadow: 'none', mt: 1 }}
            >
                {DELETE_CLASS_POPUP_DELETE}
            </Button>
            {loading &&
                <CircularProgress sx={{alignSelf: 'center'}}/>
            }
        </>
    )
};

export default DeleteClass;
